import { api } from './api';

export async function getVirtualGoods() {
  try {
    const { data } = await api.get('virtualgoods/item?player=me&orderby=extra.order&reverse=false');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getExperienceCatalog() {
  try {
    const { data } = await api.get('database/experiencias__c');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getVirtualGood(_id: string) {
  try {
    const { data } = await api.get(`virtualgoods/item/${_id}`);
    return data;
  } catch (error) {
    return error;
  }
}

export async function purchaseItem(item: string, player: string) {
  try {
    const { data } = await api.post('virtualgoods/purchase', {
      item,
      player,
    });
    return data;
  } catch (error) {
    return error;
  }
}

export async function getStore(player: string) {
  try {
    const { data } = await api.post(`find/store`, {
      player
    });

    if (Array.isArray(data)) {
      return data[0];
    }
    return data;
  } catch (error) {
    return error;
  }
}

export async function getPurchase(player: string, item: string) {
  try {
    const { data } = await api.post(`find/purchases`, {
      player,
      item
    });

    return data;
  } catch (error) {
    return error;
  }
}

export async function getCouponStatus(couponId: string) {
  try {
    const { data } = await api.post(`find/coupons`, {
      _id: couponId
    });
    return data;
  } catch (error) {
    return error;
  }
}

/**
 * Cortesias do jogador logado para um parceiro, com status de resgate.
 *
 * O recorte por jogador acontece no servidor: o aggregate `player_rewards`
 * lê o jogador do contexto do token, não de um parâmetro, então não há como
 * pedir as cortesias de outra pessoa.
 *
 * Substituiu uma chamada direta a /v3/database/rewards__c/aggregate que
 * montava um header Basic com a chave e o secret de administrador dentro do
 * bundle, e que trazia as compras de todos os jogadores do parceiro para
 * filtrar no browser.
 */
export async function getPlayerRewards(parent = "salonpatinesmusic") {
  try {
    const { data } = await api.post(`find/player_rewards`, { id: parent });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Erro ao buscar as cortesias do jugador:", error);
    return [];
  }
}
